import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=41d72968&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"
import style0 from "./configuration.vue?vue&type=style&index=0&id=41d72968&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d72968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d72968')) {
      api.createRecord('41d72968', component.options)
    } else {
      api.reload('41d72968', component.options)
    }
    module.hot.accept("./configuration.vue?vue&type=template&id=41d72968&scoped=true", function () {
      api.rerender('41d72968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/configuration/configuration.vue"
export default component.exports